<!-- 组织架构树 -->
<template>
  <div>
    <el-tree ref="depTree" :data="frameTree" :props="defaultProps" :expand-on-click-node="true"
      :filter-node-method="filterNode" :default-expanded-keys="defaultExpandedKeys" highlight-current node-key="deptId"
      @current-change="currentOrgChangeHandler" @node-expand="treeExpand" @node-collapse="treeCollapse">
      <template #default="{ data }">
        <div style="display:flex;align-items:center">
          <slot :data="data">
            <img :src="icon" style=" margin-right: 6px" alt="部门图片" />
          </slot>
          <span style="font-size:14px">{{ data.deptName }}</span>
        </div>
      </template>
    </el-tree>
  </div>
</template>

<script>
import orgFrameworkConfig from "@/CommonDP/service/org-service";
import { mapState } from "vuex";
export default {
  props: {
    filterText: { type: String, required: false, default: "" },
    currentRow: { type: Object, required: false, default: () => {} },
    roleType: { type: String, required: false, default: "" }
  },
  data() {
    return {
      frameTree: [],
      defaultProps: {
        children: "children",
        label: "depName"
      },
      defaultExpandedKeys: [],
      icon: require("@/CommonDP/assets/doc/folder_icon.png")
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  watch: {
    filterText(val) {
      this.$refs.depTree.filter(val);
    }
  },
  created() {
    this.queryFrameTree();
  },
  methods: {
    queryFrameTree() {
      this.getFrameTree().then(() => {
        const node = {
          data: this.frameTree[0]
        };
        if (this.frameTree.length > 0) this.currentOrgChangeHandler(this.frameTree[0], node);
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.deptName.indexOf(value) !== -1;
    },
    async getFrameTree(val) {
      return orgFrameworkConfig.getOrgTree(this.enterpriseId).then(({ data }) => {
        this.frameTree = data;
        this.$emit("orgData", this.frameTree); // 组件架构使用该方法，当添加，修改的时候进行赋值
        if (this.frameTree.length > 0 && !val) {
          const node = {
            data: this.frameTree[0]
          };
          if (!this.roleType) this.$emit("orgcurrent", this.frameTree[0], node);
          else this.$emit("orgcurrent", [this.frameTree[0], node]);
          this.defaultExpandedKeys.push(data[0].deptId);
          this.$nextTick(() => {
            this.$refs.depTree.setCurrentKey(data[0].deptId);
          });
        }
        this.$nextTick(() => {
          if (this.currentRow && this.currentRow.deptId) this.$refs.depTree.setCurrentKey(this.currentRow.deptId);
        });
      });
    },
    currentOrgChangeHandler(val, node) {
      if (!this.roleType) this.$emit("orgcurrent", val, node);
      else this.$emit("orgcurrent", [val, node]);
      this.$emit("orgData", this.frameTree); // 组件架构使用该方法，当添加，修改的时候进行赋值
    },
    // 单个树展开
    treeExpand(data, node) {
      if (!this.roleType) this.$emit("orgcurrent", data);
      else this.$emit("orgcurrent", [data, node]);
      this.$refs.depTree.setCurrentKey(data.deptId);
    },
    // 单个树收起
    treeCollapse(data, node) {
      if (!this.roleType) this.$emit("orgcurrent", data, node);
      else this.$emit("orgcurrent", [data, node]);
      this.$refs.depTree.setCurrentKey(data.deptId);
    }
  }
};
</script>

<style lang="less" scoped></style>
